import { useCallback } from 'react';

import PostUploadCampaignTemplatePresignedUrl from '../services/adapters/uploadCampaignTemplatePresignedUrl';
import usePresignedFileUpload, { PresignedUploadResult } from './usePresignedFileUpload';

export default function useCampaignTemplateFileUpload(benefitName: string, onComplete?: (s3Key: string) => void) {
  const getPresignedUrl = useCallback(async (fileName: string): Promise<PresignedUploadResult<string>> => {
    const adapter = new PostUploadCampaignTemplatePresignedUrl();
    const { putPresignedUrl, templateS3Key } = await adapter.adaptResponse({
      benefitName,
      fileName,
    });
    return { url: putPresignedUrl, meta: templateS3Key };
  }, [benefitName]);

  const {
    fileName, isUploading, uploadError, resetUpload, uploadFile,
  } = usePresignedFileUpload(getPresignedUrl, onComplete);

  return {
    templateFileName: fileName,
    templateIsUploading: isUploading,
    templateUploadError: uploadError,
    resetUpload,
    uploadFile,
  };
}
